import { Component, OnInit } from '@angular/core';
import { DataService } from '../service/data.service';
import { BaseComponent } from '../base.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less']
})
export class DetailsComponent extends BaseComponent implements OnInit {

  formId:string;
  isParameterForm:boolean = false;

  constructor(data:DataService, private activatedRoute: ActivatedRoute) {
    super(data);

    this.activatedRoute.params.subscribe(params => {
      this.formId = params['id'];
    });

    // Retrieve query parameters
    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.isParameterForm = queryParams['isParameterForm'] === 'true'; // Parse as boolean
    });
  }

  ngOnInit() {
    this.data.gteFormView(this.formId, this.isParameterForm);
  }

}
